import { api } from '@kolab/dms-base/api'
import type {
  DistributorLicense,
  IssueDistributorLicenseRequest,
  PageableQuery,
  PaginatedResponse,
  SetDistributorLicenseStatusRequest,
  UpdateDistributorLicenseRequest,
} from './types'

const BASE = '/v1/distributor-licenses'

export interface ListDistributorLicensesQuery extends PageableQuery {
  distributorId?: string
}

export async function listDistributorLicenses(params?: ListDistributorLicensesQuery) {
  return api.get<PaginatedResponse<DistributorLicense>>(BASE, { params, _suppressErrorToast: true }).then((r) => r.data)
}

export async function getDistributorLicense(id: string) {
  return api.get<DistributorLicense>(`${BASE}/${id}`).then((r) => r.data)
}

export async function issueDistributorLicense(payload: IssueDistributorLicenseRequest) {
  return api.post<DistributorLicense>(BASE, payload).then((r) => r.data)
}

export async function updateDistributorLicense(id: string, payload: UpdateDistributorLicenseRequest) {
  return api.put<DistributorLicense>(`${BASE}/${id}`, payload).then((r) => r.data)
}

export async function setDistributorLicenseStatus(id: string, payload: SetDistributorLicenseStatusRequest) {
  return api.put<DistributorLicense>(`${BASE}/${id}/status`, payload).then((r) => r.data)
}
